import { Button, TextField } from "@mui/material";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { BsDash, BsPatchPlus, BsPencilFill, BsPenFill, BsPlus, BsPlusCircle, BsTelephoneMinus, BsThreeDots } from "react-icons/bs";

interface IAmountInputProps {
    onChange?: (newVal: number, increment:boolean) => void;
}

const AmountInputV2 = (props:IAmountInputProps) => {

    const { t } = useTranslation();

    const inputRef = useRef<HTMLInputElement>(null);


    const handleIncrement = (newVal:number) => {
        if(props.onChange){
            props.onChange(newVal, true);
        }
    }
    const handleSetAmount = (newVal:number) => {
        if(props.onChange){
            props.onChange(newVal, false);
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
       
            const value = e.currentTarget.value;
            const intVal = parseInt(value);

            if(!isNaN(intVal)){
                handleSetAmount(intVal);
                console.log("onEnter", intVal);
                
                
            }

            setShowInput(false);
        }
        else if (e.key === 'Escape') {
            setShowInput(false);
        }

    };

    const handleBlur = () => {
        if (inputRef.current) {
            const value = inputRef.current.value;
            const intVal = parseInt(value);

            if(!isNaN(intVal)){
                handleSetAmount(intVal);
                console.log("onBlur", intVal);

            }

            setShowInput(false);
        }
    };

    const [showInput, setShowInput] = useState<boolean>(false);

    // const [quickAddOpen, setQuickAddOpen] = useState(false);
    const [quickAddOpen, setQuickAddOpen] = useState(true);

    const toggleQuickAdd = () => {
        setQuickAddOpen(prev => (!prev));
    };

    return (
        <div className="flex items-center space-x-2 mt-4">
            {/* <button
                onClick={(event) => {
                    handleIncrement(-1);
                    event.preventDefault();
                    event.stopPropagation();
                }}
                // disabled={item.scanned === 0}
                className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-200 transition-colors"
            >
                <BsDash className="w-4 h-4" />
            </button> */}
           
            {/* <span className="w-8 text-center font-medium">{item.scanned}</span> */}
           
            {/* <button
                onClick={(event) => {
                    handleIncrement(1);
                    event.preventDefault();
                    event.stopPropagation();
                }}
                className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center hover:bg-blue-200 transition-colors"
            >
                <BsPlus className="w-4 h-4" />
            </button> */}

            {/* Expandable Quick Add */}
            <div className="relative">
                <div className={`flex items-center overflow-hidden transition-all duration-300 ease-in-out ${quickAddOpen ? 'w-49 opacity-100' : 'w-8 opacity-100'
                    }`}>
                    <button
                        onClick={() => toggleQuickAdd()}
                        className={`w-8 h-8 rounded-l-full bg-blue-100 text-blue-600 flex items-center justify-center hover:bg-blue-200 transition-colors ${quickAddOpen ? 'rounded-r-none' : 'rounded-r-full'
                            }`}
                    >
                        <BsPlus className="w-4 h-4" />
                        {/* <BsThreeDots className="w-4 h-4" /> */}
                    </button>

                    {quickAddOpen && (
                        <div className="flex items-center bg-white border border-l-0 border-gray-200 rounded-r-lg h-8 px-2 space-x-1">
                            <button
                                onClick={(event) => {
                                    handleIncrement(1);
                                    event.preventDefault();
                                    event.stopPropagation();
                                }}
                                className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs hover:bg-gray-200 transition-colors font-medium"
                            >
                                +1
                            </button>
                            <button
                                onClick={(event) => {
                                    handleIncrement(5);
                                    event.preventDefault();
                                    event.stopPropagation();
                                }}
                                className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs hover:bg-gray-200 transition-colors font-medium"
                            >
                                +5
                            </button>
                            <button
                                onClick={(event) => {
                                    handleIncrement(10);
                                    event.preventDefault();
                                    event.stopPropagation();
                                }}
                                className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs hover:bg-gray-200 transition-colors font-medium"
                            >
                                +10
                            </button>

                            <input
                                ref={inputRef}
                                type="number"
                                min="1"
                                placeholder="?"
                                // value={customAmount}
                                // onChange={(e) => setCustomAmount(e.target.value)}
                                className="w-8 px-1 py-1 border border-gray-300 rounded text-xs text-center focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                // onKeyPress={(e) => e.key === 'Enter' && addCustomAmount(item.id)}

                                onBlur={handleBlur}
                                onKeyDown={handleKeyDown}
                            />
                        
                            {/* <TextField
                                inputRef={inputRef}
                                autoFocus
                                label={t("common:customAmountLabel")}
                                variant="outlined"         // you can also use "filled" or "standard"
                                size="small"
                                // fullWidth
                                margin="normal"
                                type="text"                // let inputMode pattern handle numeric pad
                                inputMode="numeric"
                                // pattern="[0-9]*"
                                // onBlur={handleBlur}
                                // onKeyDown={handleKeyDown}

                                inputProps={{
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*',
                                    onBlur: handleBlur,
                                    onKeyDown: handleKeyDown
                                }}
                                className="h-12 min-w-[60px] w-[80px] px-4 font-medium rounded-lg transition-colors duration-200"

                                sx={{
                                    '& .MuiInputBase-root': { height: '48px' },
                                }}
                            /> */}
                            
                            <button
                                onClick={handleBlur}
                                // disabled={!customAmount || parseInt(customAmount) <= 0}
                                className="px-1 py-1 bg-blue-100 text-blue-600 rounded text-xs hover:bg-blue-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                ✓
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    // return (
    //     <div className="flex flex-row gap-4  items-center">
    //         <Button 
    //             variant="outlined" 
    //             onClick={(event) => {
    //                 handleIncrement(1);
    //                 event.preventDefault();
    //                 event.stopPropagation();
    //             }}

    //             size="small" 
    //             className="min-w-[60px] px-4 font-medium rounded-lg transition-colors duration-200"
    //             sx={{ 
    //                 height: '48px',
    //                 marginTop: "16px",
    //                 marginBottom: "8px"
    //             }}
    //         >
    //             +1
    //         </Button>
    //         <Button 
    //             variant="outlined" 
    //             onClick={(event) => {
    //                 handleIncrement(5);
    //                 event.preventDefault();
    //                 event.stopPropagation();
    //             }}

    //             size="small" 
    //             className="min-w-[60px] px-4 font-medium rounded-lg transition-colors duration-200"
    //             sx={{ 
    //                 height: '48px',
    //                 marginTop: "16px",
    //                 marginBottom: "8px"
    //             }}
    //         >
    //             +5
    //         </Button>
    //         <Button 
    //             variant="outlined" 
    //             onClick={(event) => {
    //                 handleIncrement(10);
    //                 event.preventDefault();
    //                 event.stopPropagation();
    //             }}

    //             size="small" 
    //             className="min-w-[60px] px-4 font-medium rounded-lg transition-colors duration-200"
    //             sx={{ 
    //                 height: '48px',
    //                 marginTop: "16px",
    //                 marginBottom: "8px"
    //             }}
    //         >
    //             +10
    //         </Button>


    //         <div className="shrink-0">
    //             {showInput
    //                 ?
    //                 <TextField
    //                     inputRef={inputRef}
    //                     autoFocus
    //                     label={t("common:customAmountLabel")}
    //                     variant="outlined"         // you can also use "filled" or "standard"
    //                     size="small"
    //                     // fullWidth
    //                     margin="normal"
    //                     type="text"                // let inputMode pattern handle numeric pad
    //                     inputMode="numeric"
    //                     // pattern="[0-9]*"
    //                     // onBlur={handleBlur}
    //                     // onKeyDown={handleKeyDown}

    //                     inputProps={{
    //                         inputMode: 'numeric',
    //                         pattern: '[0-9]*',
    //                         onBlur: handleBlur,
    //                         onKeyDown: handleKeyDown
    //                     }}
    //                     className="h-12 min-w-[60px] w-[80px] px-4 font-medium rounded-lg transition-colors duration-200"

    //                     sx={{
    //                         '& .MuiInputBase-root': { height: '48px' },
    //                     }}
    //                 />
                        

    //                 :
    //                 <Button 
    //                     variant="outlined" 
    //                     size="small" 
    //                     className="h-12 w-20 px-3 border border-gray-300 rounded-lg text-center"

    //                     onClick={(event) => {
    //                         // handleOnChange()

    //                         setShowInput(true);

    //                         event.preventDefault();
    //                         event.stopPropagation();
    //                     }}

    //                     sx={{ 
    //                         height: '48px',
    //                         marginTop: "16px",
    //                         marginBottom: "8px"
    //                     }}
    //                 >
    //                     <BsPencilFill />
    //                 </Button>
    //             }



    //         </div>

    //     </div>
    // )

};

export default AmountInputV2;
